import React from 'react';

interface Context {
  actualFields: string[];
  remainingFields: string[];
  futureFixedFields: string[];
  futureFixedRemainingFields: string[];
  data: any[];
}

export const initialState: Context = {
  actualFields: null,
  remainingFields: null,
  futureFixedFields: null,
  futureFixedRemainingFields: null,
  data: null,
};

const ExpendituresChartContext = React.createContext<Context>(initialState);

export default ExpendituresChartContext;
